import config from "@/config"
import http from "@/utils/request"
import { get } from "sortablejs";

export default {

    GetSystemUsersList: {
        url: `${config.API_URL}/System/SystemUsers/GetSystemUsersList`,
        name: "",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    },
    
    GetSystemUsersById: {
        url: `${config.API_URL}/System/SystemUsers/GetUserById`,
        name: "",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    }, 
    
    UserDelete: {
        url: `${config.API_URL}/System/SystemUsers/UserDelete`,
        name: "",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    }, 
    
    SystemUsersChange: {
        url: `${config.API_URL}/System/SystemUsers/SystemUsersChange`,
        name: "",
        post: async function (params) {
            return await http.post(this.url, params);
        }
    },
  
     GetSystemSubscribeInfoList: {
        url: `${config.API_URL}/System/SystemSubscribeInfo/GetSystemSubscribeInfoList`,
        name: "",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    },
      GetSystemSubscribeInfoById: {
        url: `${config.API_URL}/System/SystemSubscribeInfo/GetSystemSubscribeInfoById`,
        name: "",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    },
    
    SystemSubscribeInfoDelete: {
        url: `${config.API_URL}/System/SystemSubscribeInfo/SystemSubscribeInfoDelete`,
        name: "",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    },
    SystemSubscribeInfoChange: {
        url: `${config.API_URL}/System/SystemSubscribeInfo/SystemSubscribeInfoChange`,
        name: "",
        post: async function (params) {
            return await http.post(this.url, params);
        }
    }, 
    
    GetProviderList: {
        url: `${config.API_URL}/System/Provider/GetProviderList`,
        name: "",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    }, 
    
    GetProviderById: {
        url: `${config.API_URL}/System/Provider/GetProviderById`,
        name: "",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    }, 
    ProviderDelete: {
        url: `${config.API_URL}/System/Provider/ProviderDelete`,
        name: "",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    },
    
    ProviderInfoChange: {
        url: `${config.API_URL}/System/Provider/ProviderInfoChange`,
        name: "",
        post: async function (params) {
            return await http.post(this.url, params);
        }
    }, 
    
    GetProviderApiKeyList: {
        url: `${config.API_URL}/System/ProviderApiKey/GetProviderApiKeyList`,
        name: "",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    },

      GetProviderApiKeyById: {
        url: `${config.API_URL}/System/ProviderApiKey/GetProviderApiKeyById`,
        name: "",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    },
    
    ProviderApiKeyDelete: {
        url: `${config.API_URL}/System/ProviderApiKey/ProviderApiKeyDelete`,
        name: "",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    },  
    
 
    ProviderApiKeyChange: {
        url: `${config.API_URL}/System/ProviderApiKey/ProviderApiKeyChange`,
        name: "",
        post: async function (params) {
            return await http.post(this.url, params);
        }
    },
    
    ProviderApiKeyPostTotalQuota: {
        url: `${config.API_URL}/System/ProviderApiKey/ProviderApiKeyPostTotalQuota`,
        name: "",
        post: async function (params) {
            return await http.post(this.url, params);
        }
    }, 
    
    GetModelMappingList: {
        url: `${config.API_URL}/System/ModelMapping/GetModelMappingList`,
        name: "",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    },
    
    GetModelMappingById: {
        url: `${config.API_URL}/System/ModelMapping/GetModelMappingById`,
        name: "",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    },

    ModelMappingDelete: {
        url: `${config.API_URL}/System/ModelMapping/ModelMappingDelete`,
        name: "",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    },
      ModelMappingChange: {
        url: `${config.API_URL}/System/ModelMapping/ModelMappingChange`,
        name: "",
        post: async function (params) {
            return await http.post(this.url, params);
        }
    }, 
    
    GetModelMappingImagersList: {
        url: `${config.API_URL}/System/ModelMapping/GetModelMappingImagersList`,
        name: "",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    },
    GetModelMappingImagersById: {
        url: `${config.API_URL}/System/ModelMappingImagers/GetModelMappingImagersById`,
        name: "",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    },
    
    ModelModelMappingImagersDelete: {
        url: `${config.API_URL}/System/ModelMappingImagers/ModelModelMappingImagersDelete`,
        name: "",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    },
     ModelMappingImagersChange: {
        url: `${config.API_URL}/System/ModelMappingImagers/ModelMappingImagersChange`,
        name: "",
        post: async function (params) {
            return await http.post(this.url, params);
        }
    }, 
    GetModelMappingImagersEnumList: {
        url: `${config.API_URL}/System/ModelMappingImagers/GetModelMappingImagersEnumList`,
        name: "",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    },
    GetModelMappingVideoEnumList: {
        url: `${config.API_URL}/System/ModelMappingVideo/GetModelMappingVideoEnumList`,
        name: "",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    },
    
    GetModelMappingVideoList: {
        url: `${config.API_URL}/System/ModelMappingVideo/GetModelMappingVideoList`,
        name: "",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    },
    
    GetModelMappingVideoById: {
        url: `${config.API_URL}/System/ModelMappingVideo/GetModelMappingVideoById`,
        name: "",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    }, 
    ModelMappingVideoDelete: {
        url: `${config.API_URL}/System/ModelMappingVideo/ModelMappingVideoDelete`,
        name: "",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    }, 
    
    ModelMappingVideoChange: {
        url: `${config.API_URL}/System/ModelMappingVideo/ModelMappingVideoChange`,
        name: "",
        post: async function (params) {
            return await http.post(this.url, params);
        }
    }, 
    
    GetProjectList: {
        url: `${config.API_URL}/System/Project/GetProjectList`,
        name: "",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    },


    GetSystemConfigList: {
        url: `${config.API_URL}/System/SystemConfig/GetSystemConfigList`,
        name: "",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    },

     GetSystemConfigById: {
        url: `${config.API_URL}/System/SystemConfig/GetSystemConfigById`,
        name: "",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    },
    SystemConfigDelete: {
        url: `${config.API_URL}/System/SystemConfig/SystemConfigDelete`,
        name: "",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    },
     SystemConfigChange: {
        url: `${config.API_URL}/System/SystemConfig/SystemConfigChange`,
        name: "",
        post: async function (params) {
            return await http.post(this.url, params);
        }
    },

     GetSystemConfigsEnumList: {
        url: `${config.API_URL}/System/SystemConfig/GetSystemConfigsEnumList`,
        name: "",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    },

    GetUserList: {
        url: `${config.API_URL}/System/Users/GetUserList`,
        name: "",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    },
    
    TopUpbalance: {
        url: `${config.API_URL}/System/Users/TopUpbalance`,
        name: "",
        post: async function (params) {
            return await http.post(this.url, params);
        }
    },
    
    GetUserAmountByUserId: {
        url: `${config.API_URL}/System/UserAmount/GetUserAmountByUserId`,
        name: "",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    }, 
    
    GetUserDiscountByUserId: {
        url: `${config.API_URL}/System/UserDiscount/GetUserDiscountByUserId`,
        name: "",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    }, 
    
    UsersDiscountChange: {
        url: `${config.API_URL}/System/Users/UsersDiscountChange`,
        name: "",
        post: async function (params) {
            return await http.post(this.url, params);
        }
    },
    
    GetUserRequestControlByUserId: {
        url: `${config.API_URL}/System/UserRequestControl/GetUserRequestControlByUserId`,
        name: "",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    }, 

      UsersRequestControlChange: {
        url: `${config.API_URL}/System/Users/UsersRequestControlChange`,
        name: "",
        post: async function (params) {
            return await http.post(this.url, params);
        }
    }, 
    
    GetUserSubscriptionRelationShipUserId: {
        url: `${config.API_URL}/System/UserSubscriptionRelationShip/GetUserSubscriptionRelationShipUserId`,
        name: "",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    }, 

     UserSubscriptionRelationShipChange: {
        url: `${config.API_URL}/System/Users/UserSubscriptionRelationShipChange`,
        name: "",
        post: async function (params) {
            return await http.post(this.url, params);
        }
    },  
    
    GetVideoJobList: {
        url: `${config.API_URL}/System/VideoJob/GetVideoJobList`,
        name: "",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    },  
    
    GetComboInfoList: {
        url: `${config.API_URL}/System/ComboInfo/GetComboInfoList`,
        name: "",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    }, 

    GetComboInfoById: {
        url: `${config.API_URL}/System/ComboInfo/GetComboInfoById`,
        name: "",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    },  
    
    ComboInfoDelete: {
        url: `${config.API_URL}/System/ComboInfo/ComboInfoDelete`,
        name: "",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    },  
     ComboInfoChange: {
        url: `${config.API_URL}/System/ComboInfo/ComboInfoChange`,
        name: "",
        post: async function (params) {
            return await http.post(this.url, params);
        }
    }, 
     GetComboModelList: {
        url: `${config.API_URL}/System/ComboModel/GetComboModelList`,
        name: "",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    },  
    
    GetComboModelById: {
        url: `${config.API_URL}/System/ComboModel/GetComboModelById`,
        name: "",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    }, 
    ComboModelDelete: {
        url: `${config.API_URL}/System/ComboModel/ComboModelDelete`,
        name: "",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    },  
    ComboModelChange: {
        url: `${config.API_URL}/System/ComboModel/ComboModelChange`,
        name: "",
        post: async function (params) {
            return await http.post(this.url, params);
        }
    },  
    
    GetUserComboList: {
        url: `${config.API_URL}/System/UserCombo/GetUserComboList`,
        name: "",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    },  
     GetRequestLogList: {
        url: `${config.API_URL}/System/RequestLog/GetRequestLogList`,
        name: "",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    },   
    
    GetRequestUserDeductLogList: {
        url: `${config.API_URL}/System/RequestUserDeductLog/GetRequestUserDeductLogList`,
        name: "",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    },  
    
    GetNotificationList: {
        url: `${config.API_URL}/System/Notification/GetNotificationList`,
        name: "",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    },  
    
    ChangeNotificationApiKeyPostTotalQuota: {
        url: `${config.API_URL}/System/Notification/ChangeNotificationApiKeyPostTotalQuota`,
        name: "",
        post: async function (params) {
            return await http.post(this.url, params);
        }
    },   
    
    ChangeUserPassword: {
        url: `${config.API_URL}/System/Login/ChangeUserPassword`,
        name: "",
        post: async function (params) {
            return await http.post(this.url, params);
        }
    },   
    
    ChangeUserMangeOpenSubAccount: {
        url: `${config.API_URL}/System/Users/ChangeUserMangeOpenSubAccount`,
        name: "",
        post: async function (params) {
            return await http.post(this.url, params);
        }
    },   
    
    UsersAddSystem: {
        url: `${config.API_URL}/System/Users/UsersAddSystem`,
        name: "",
        post: async function (params) {
            return await http.post(this.url, params);
        }
    },  
    GetModelMappingRestrictionConfigList: {
        url: `${config.API_URL}/System/ModelMappingRestrictionConfig/GetModelMappingRestrictionConfigList`,
        name: "",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    },  

    GetModelMappingRestrictionConfigById: {
        url: `${config.API_URL}/System/ModelMappingRestrictionConfig/GetModelMappingRestrictionConfigById`,
        name: "",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    },  
    
    ModelMappingRestrictionConfigDelete: {
        url: `${config.API_URL}/System/ModelMappingRestrictionConfig/ModelMappingRestrictionConfigDelete`,
        name: "",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    },  
    ModelMappingRestrictionConfigChange: {
        url: `${config.API_URL}/System/ModelMappingRestrictionConfig/ModelMappingRestrictionConfigChange`,
        name: "",
        post: async function (params) {
            return await http.post(this.url, params);
        }
    },  

     UserModelDiscountChange: {
        url: `${config.API_URL}/System/UserModelDiscount/UserModelDiscountChange`,
        name: "",
        post: async function (params) {
            return await http.post(this.url, params);
        }
    }, 

    UserModelDiscountDelete: {
        url: `${config.API_URL}/System/UserModelDiscount/UserModelDiscountDelete`,
        name: "",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    }, 
    GetUserModelDiscountById: {
        url: `${config.API_URL}/System/UserModelDiscount/GetUserModelDiscountById`,
        name: "",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    }, 

     GetUserModelDiscountList: {
        url: `${config.API_URL}/System/UserModelDiscount/GetUserModelDiscountList`,
        name: "",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    },  
    
    UserModelDiscountDefaultChange: {
        url: `${config.API_URL}/System/UserModelDiscount/UserModelDiscountDefaultChange`,
        name: "",
        post: async function (params) {
            return await http.post(this.url, params);
        }
    }, 
  GetModelDiscountList: {
        url: `${config.API_URL}/System/ModelDiscount/GetModelDiscountList`,
        name: "",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    },  
    
    GetModelDiscountById: {
        url: `${config.API_URL}/System/ModelDiscount/GetModelDiscountById`,
        name: "",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    }, 
    
    ModelDiscountDelete: {
        url: `${config.API_URL}/System/ModelDiscount/ModelDiscountDelete`,
        name: "",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    }, 
    
    ModelDiscountChange: {
        url: `${config.API_URL}/System/ModelDiscount/ModelDiscountChange`,
        name: "",
        post: async function (params) {
            return await http.post(this.url, params);
        }
    },  
    
    GetRechargeOrderList: {
        url: `${config.API_URL}/System/RechargeOrder/GetRechargeOrderList`,
        name: "",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    }, 

      GetInviteRebateRecordList: {
        url: `${config.API_URL}/System/InviteRebateRecord/GetInviteRebateRecordList`,
        name: "",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    }, 
    
    CheckUsePublicModel: {
        url: `${config.API_URL}/System/Users/CheckUsePublicModel`,
        name: "",
        post: async function (params) {
            return await http.post(this.url, params);
        }
    }, 
    
    ChangeUserSpecialPromotion: {
        url: `${config.API_URL}/System/Users/ChangeUserSpecialPromotion`,
        name: "",
        post: async function (params) {
            return await http.post(this.url, params);
        }
    }, 
     
}